/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { DeleteProjectItemTaskCommand } from '../../models/delete-project-item-task-command';
import { DeleteProjectItemTaskCommandResult } from '../../models/delete-project-item-task-command-result';

export interface ApiProjectItemsTasksDeleteProjectItemTaskDelete$Plain$Params {
      body?: DeleteProjectItemTaskCommand
}

export function apiProjectItemsTasksDeleteProjectItemTaskDelete$Plain(http: HttpClient, rootUrl: string, params?: ApiProjectItemsTasksDeleteProjectItemTaskDelete$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<DeleteProjectItemTaskCommandResult>> {
  const rb = new RequestBuilder(rootUrl, apiProjectItemsTasksDeleteProjectItemTaskDelete$Plain.PATH, 'delete');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<DeleteProjectItemTaskCommandResult>;
    })
  );
}

apiProjectItemsTasksDeleteProjectItemTaskDelete$Plain.PATH = '/api/ProjectItemsTasks/DeleteProjectItemTask';
